import styled from 'styled-components';

export const GridWrapper = styled.div`
    width: 100%;
    height: 60vh;
    --ag-borders: none;
    /* then add back a border between rows */
    --ag-row-border-style: solid;
    --ag-row-border-width: 5px;
    --ag-row-border-color: black;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #133366;
        color: #FFF;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        // line-height: 33px;
        border-color: #ccc;
        // font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            .totals {
                font-weight: 600;
                background-color: #ddd;
            }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }
        }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
    
    .ag-header-cell-label {
        justify-content: center;
      }
    
    .ag-header-cell {
        justify-content: center;
    }

    .ag-theme-alpine {
        /* disable all borders */
        --ag-borders: none;
        /* then add back a border between rows */
        --ag-row-border-style: solid;
        --ag-row-border-width: 5px;
        --ag-row-border-color: black;
      }
`;